import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SubPageHeading from '../../../../organisms/SubPageHeading';
import { subPageNavEdit, subPageNavNew } from './ManagementContainer.constants';

const ManagementContainer = () => {
  const {
    state: { name, navPage, subNav, id },
  } = useLocation();

  const subPageNavEditExtended = subPageNavEdit.map((item) => ({
    ...item,
    state: {
      navPage,
      subNav,
      name,
      id,
    },
  }));

  return (
    <>
      <SubPageHeading
        subPageNav={name ? subPageNavEditExtended : subPageNavNew}
        subPageHeading={name || 'New Management'}
        name={name}
        nav={{
          to: '/db/datahandling/managements',
          state: {
            navPage,
            subNav,
          },
        }}
      />
      <Outlet />
    </>
  );
};

export default ManagementContainer;
